import React, { memo } from 'react';

import { createPortal } from 'react-dom';

import { usePlacementPortalContainer } from '../../../common/utils/post-office-placement/placement-portal-context';
import { QuickFindBannerPlacement } from '../../../common/utils/post-office-placement/quick-find-banner-placement/rml-placement';
import { useOAuthHandlers } from '../../oauth';

import { useQuickFindBannerPlacementConfig } from './use-config';

type QuickFindBannerPortalProps = {
	onBannerMessageViewed?: (trackImpression: () => void) => void;
	isInteracted?: boolean;
};

export const QuickFindBannerPortal: React.MemoExoticComponent<
	(props: QuickFindBannerPortalProps) => React.ReactPortal | null
> = memo(
	({
		onBannerMessageViewed,
		isInteracted,
	}: QuickFindBannerPortalProps): React.ReactPortal | null => {
		const portalContainer = usePlacementPortalContainer();
		const { thirdPartyConfigs, bannerEligibleProductsOrder, shouldMountPlacement } =
			useQuickFindBannerPlacementConfig(isInteracted);

		if (!shouldMountPlacement || !portalContainer) {
			return null;
		}

		// Render the Quick Find banner placement into the dialog's portal container so the
		// placement is mounted when results are shown, without changing the main results DOM.
		return createPortal(
			<QuickFindBannerPlacement
				thirdPartyConfigs={thirdPartyConfigs}
				availableProductsOrder={bannerEligibleProductsOrder}
				useOAuthHandlers={useOAuthHandlers}
				onMessageViewed={onBannerMessageViewed}
			/>,
			portalContainer,
		);
	},
);
